import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class CartaPorteAutotransporteSegurosForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isTouched: true,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    const isTouched = this.state.isTouched;

    const AseguraRespCivil = ['string', 'min:3', 'max:50'];
    const PolizaRespCivil = ['string', 'min:3', 'max:30'];

    return {
      'AseguraRespCivil': isTouched ? ['required'].concat(AseguraRespCivil) : AseguraRespCivil,
      'PolizaRespCivil': isTouched ? ['required'].concat(PolizaRespCivil) : PolizaRespCivil,
      'AseguraMedAmbiente': ['string', 'min:3', 'max:50'],
      'PolizaMedAmbiente': ['string', 'min:3', 'max:30'],
      'AseguraCarga': ['string', 'min:3', 'max:50'],
      'PolizaCarga': ['string', 'min:3', 'max:30'],
      'PrimaSeguro': ['string', 'min:0.000000', 'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      isValid: validator.passes()
    });

    this.props.onFormDataChange({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  render() {
    const { data } = this.props;

    const rules = this.rules(data);

    return (
      <>
        <div>
          <strong>Seguros</strong>
        </div>

        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Aseguradora de responsabilidad civil"
              name="AseguraRespCivil"
              placeholder=""
              help=""
              minLength="3"
              maxLength="50"
              rules={ rules.AseguraRespCivil }
              value={ data.AseguraRespCivil }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de póliza de responsabilidad civil"
              name="PolizaRespCivil"
              placeholder=""
              help=""
              minLength="3"
              maxLength="30"
              rules={ rules.PolizaRespCivil }
              value={ data.PolizaRespCivil }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Aseguradora de daños al medio ambiente"
              name="AseguraMedAmbiente"
              placeholder=""
              help=""
              minLength="3"
              maxLength="50"
              rules={ rules.AseguraMedAmbiente }
              value={ data.AseguraMedAmbiente }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de póliza por daños al medio ambiente"
              name="PolizaMedAmbiente"
              placeholder=""
              help=""
              minLength="3"
              maxLength="30"
              rules={ rules.PolizaMedAmbiente }
              value={ data.PolizaMedAmbiente }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Aseguradora de la carga transportada"
              name="AseguraCarga"
              placeholder=""
              help=""
              minLength="3"
              maxLength="50"
              rules={ rules.AseguraCarga }
              value={ data.AseguraCarga }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de póliza de la carga transportada"
              name="PolizaCarga"
              placeholder=""
              help=""
              minLength="3"
              maxLength="30"
              rules={ rules.PolizaCarga }
              value={ data.PolizaCarga }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Valor de la prima del seguro"
              name="PrimaSeguro"
              placeholder=""
              help=""
              rules={ rules.PrimaSeguro }
              value={ data.PrimaSeguro }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteAutotransporteSegurosForm;